export interface TableHeaderCellIdentityLike {
  rowId?: string;
  colId?: string;
  row?: number;
  col?: number;
  gridPosition?: {
    row: number;
    col: number;
  };
}

export interface TableHeaderStructureLike {
  hasHeaderRow?: boolean;
  hasHeaderColumn?: boolean;
  rowOrder?: string[];
  colOrder?: string[];
}

const getTableCellGridPosition = (
  cell: TableHeaderCellIdentityLike,
  table: TableHeaderStructureLike,
): { row: number; col: number } | undefined => {
  if (cell.rowId && cell.colId && table.rowOrder && table.colOrder) {
    const row = table.rowOrder.indexOf(cell.rowId);
    const col = table.colOrder.indexOf(cell.colId);

    if (row !== -1 && col !== -1) {
      return { row, col };
    }
  }

  if (cell.gridPosition) {
    return cell.gridPosition;
  }

  if (cell.row !== undefined && cell.col !== undefined) {
    return { row: cell.row, col: cell.col };
  }

  return undefined;
};

export const isTableHeaderCell = (
  cell: TableHeaderCellIdentityLike,
  table: TableHeaderStructureLike,
): boolean => {
  const gridPosition = getTableCellGridPosition(cell, table);

  if (!gridPosition) {
    return false;
  }

  return (
    (table.hasHeaderRow === true && gridPosition.row === 0) ||
    (table.hasHeaderColumn === true && gridPosition.col === 0)
  );
};
